import { z } from "zod";

export const newMeetingSchema = z.object({
  family: z.string().min(1, "חובה לכתוב שם משפחה"),
  date: z.string()
   .min(1, "חובה לבחור תאריך") 
   .refine(
    (val) => {
      const selectedDate = new Date(val);
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      return selectedDate >= now;
    },
    { message: "לא ניתן לבחור תאריך בעבר" }
  ),
  location: z.string().min(1, "יש להזין מיקום"),
  attendees:z.string().min(1,"חובה לכתוב לפחות משתתף אחד"),
});

export type MeetingFormValues = z.infer<typeof newMeetingSchema>;
